export const errorCodes = {
  'PHW-D-001': 'Dev/Demo error',
  'PHW-F-001': 'Firebase permission denied',
  'PHW-F-002': 'Firebase snapshot listener setup error',
  'PHW-P-001': 'PROSE protocolService.render returned error',
  'PHW-P-002': 'PROSE protocolService thrown error',
  'PHW-P-003': 'PROSE module corrupted after panic',
  'PHW-Q-001': 'Error caught in questionnaire snapshot handler',
  'PHW-X-001': 'Unknown error',
} as const;
